import "./Styles/App.css";
import {Parallax, ParallaxLayer} from "@react-spring/parallax";
import {Container, Row, Col} from "react-bootstrap";
import Fade from "react-reveal/Fade";
import Work from "./Components/Work.js";
import Projects from "./Components/Projects.js";

function App() {
	return (
		<div className="App">
			<div className="social-icons">
				<span>
					<a
						href="https://www.linkedin.com/in/lindenstkwok/"
						target="_blank"
						rel="noreferrer"
					>
						<svg
							enable-background="new 0 0 24 24"
							height="512"
							viewBox="0 0 24 24"
							width="512"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z" />
							<path d="m.396 7.977h4.976v16.023h-4.976z" />
							<path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z" />
						</svg>
					</a>
				</span>
				<span>
					<a href="https://github.com/l-kwok" target="_blank" rel="noreferrer">
						<svg
							enable-background="new 0 0 24 24"
							height="512"
							viewBox="0 0 24 24"
							width="512"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="m12 .5c-6.63 0-12 5.28-12 11.792 0 5.211 3.438 9.63 8.205 11.188.6.111.82-.254.82-.567 0-.28-.01-1.022-.015-2.005-3.338.711-4.042-1.582-4.042-1.582-.546-1.361-1.335-1.725-1.335-1.725-1.087-.731.084-.716.084-.716 1.205.082 1.838 1.215 1.838 1.215 1.07 1.803 2.809 1.282 3.495.981.108-.763.417-1.282.76-1.577-2.665-.295-5.466-1.309-5.466-5.827 0-1.287.465-2.339 1.235-3.164-.135-.298-.54-1.497.105-3.121 0 0 1.005-.316 3.3 1.209.96-.262 1.98-.392 3-.398 1.02.006 2.04.136 3 .398 2.28-1.525 3.285-1.209 3.285-1.209.645 1.624.24 2.823.12 3.121.765.825 1.23 1.877 1.23 3.164 0 4.53-2.805 5.527-5.475 5.817.42.354.81 1.077.81 2.182 0 1.578-.015 2.846-.015 3.229 0 .309.21.678.825.56 4.801-1.548 8.236-5.97 8.236-11.173 0-6.512-5.373-11.792-12-11.792z" />
						</svg>
					</a>
				</span>
			</div>
			<Parallax
				class="Parent-Parallax d-flex justify-content-center"
				pages={4}
				style={{top: "0", left: "0"}}
			>
				<ParallaxLayer
					offset={0}
					speed={1}
					factor={1}
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						backgroundColor: "#ff8247",
					}}
				></ParallaxLayer>
				<ParallaxLayer
					offset={0}
					speed={2.5}
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Fade bottom>
						<div className="content-wrapper">
							<h1>Linden Kwok.</h1>
						</div>
					</Fade>
				</ParallaxLayer>
				<ParallaxLayer
					offset={0}
					speed={2}
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Fade bottom>
						<div className="content-wrapper">
							<h5 id="landing-role">software developer</h5>
						</div>
					</Fade>
				</ParallaxLayer>
				<ParallaxLayer
					offset={0}
					speed={1.5}
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Fade bottom>
						<div className="content-wrapper">
							<h6 id="landing-location">Vancouver, BC</h6>
						</div>
					</Fade>
				</ParallaxLayer>

				<ParallaxLayer
					offset={1}
					speed={1}
					factor={4}
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						backgroundColor: "#2F3E5A",
					}}
				/>

				<ParallaxLayer
					offset={1.5}
					speed={1.5}
					factor={1.5}
					className="content"
				>
					<Container fluid>
						<Row>
							<Col className="d-flex flex-row justify-content-center">
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										width: "1300px",
										marginLeft: "700px",
									}}
								>
									<img
										src="./Images/mouse-edit.png"
										alt="mouse"
										id="mouse-img"
									></img>
								</div>
							</Col>
						</Row>
					</Container>
				</ParallaxLayer>
				<ParallaxLayer
					offset={1}
					speed={1}
					factor={1.5}
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						color: "black",
					}}
				>
					<Container fluid>
						<Row>
							<Col className="d-flex flex-row justify-content-center">
								<div className="rounded-box" id="about">
									<h2 id="about-title">About.</h2>
									<p>
										Hello, I'm Linden. I graduated from Simon Fraser University
										in 2020 with a Bachelor's Degree in Computer Science and
										completed an Associate’s Degree in Computer Science from
										Langara in 2017.
										<br />
										<br />I am a solution-oriented software developer with
										interests in data security, artificial intelligence,
										algorithm efficiency, and full stack web development.
										Self-motivated and team focused work attitude.
									</p>
								</div>
							</Col>
						</Row>
					</Container>
				</ParallaxLayer>
				<ParallaxLayer
					offset={1.93}
					speed={1.5}
					factor={1.95}
					className="content"
				>
					<Container fluid>
						<Row>
							<Col className="d-flex flex-row justify-content-center">
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										width: "1300px",
										marginRight: "700px",
									}}
								>
									<img
										src="./Images/keyboard-edit-2.png"
										alt="keyboard"
										id="keyboard-img"
									></img>
								</div>
							</Col>
						</Row>
					</Container>
				</ParallaxLayer>

				<ParallaxLayer
					offset={1.99}
					speed={1.2}
					factor={1}
					style={{marginTop: "340px"}}
				>
					<Work></Work>
					<Projects></Projects>
				</ParallaxLayer>

				<ParallaxLayer
					offset={3}
					speed={0.8}
					factor={1}
					style={{marginTop: "15%"}}
				>
					<Container fluid className="contact-section">
						<Row>
							<Col className="d-flex justify-content-center">
								<div className="rounded-box" style={{maxWidth: "90%"}}>
									<h2>Hello.</h2>
									<h4>lindenstkwok</h4>
									<h4 style={{fontSize: "1rem", marginLeft: "30%"}}>@gmail.com</h4>
									<p style={{padding: "0"}}>
										Interested in working together? Need a website? I would love
										to hear from you!
									</p>
									<p style={{padding: "0", marginBottom: "0.25rem"}}>
										Linden Kwok <br></br>Vancouver, Canada
									</p>
									<div className="contact-social-icons">
										<span>
											<a href="https://www.linkedin.com/in/lindenstkwok/">
												<svg
													className="icon"
													enable-background="new 0 0 24 24"
													height="512"
													viewBox="0 0 24 24"
													width="512"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z" />
													<path d="m.396 7.977h4.976v16.023h-4.976z" />
													<path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z" />
												</svg>
											</a>
										</span>
										<span>
											<a href="https://github.com/l-kwok">
												<svg
													className="icon"
													enable-background="new 0 0 24 24"
													height="512"
													viewBox="0 0 24 24"
													width="512"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path d="m12 .5c-6.63 0-12 5.28-12 11.792 0 5.211 3.438 9.63 8.205 11.188.6.111.82-.254.82-.567 0-.28-.01-1.022-.015-2.005-3.338.711-4.042-1.582-4.042-1.582-.546-1.361-1.335-1.725-1.335-1.725-1.087-.731.084-.716.084-.716 1.205.082 1.838 1.215 1.838 1.215 1.07 1.803 2.809 1.282 3.495.981.108-.763.417-1.282.76-1.577-2.665-.295-5.466-1.309-5.466-5.827 0-1.287.465-2.339 1.235-3.164-.135-.298-.54-1.497.105-3.121 0 0 1.005-.316 3.3 1.209.96-.262 1.98-.392 3-.398 1.02.006 2.04.136 3 .398 2.28-1.525 3.285-1.209 3.285-1.209.645 1.624.24 2.823.12 3.121.765.825 1.23 1.877 1.23 3.164 0 4.53-2.805 5.527-5.475 5.817.42.354.81 1.077.81 2.182 0 1.578-.015 2.846-.015 3.229 0 .309.21.678.825.56 4.801-1.548 8.236-5.97 8.236-11.173 0-6.512-5.373-11.792-12-11.792z" />
												</svg>
											</a>
										</span>
									</div>
								</div>
							</Col>
						</Row>
						<Row>
							<Col className="d-flex justify-content-center">
								<p style={{fontSize: "0.7rem"}}>
									&copy; Copyright 2021 Linden Kwok.
								</p>
							</Col>
						</Row>
					</Container>
				</ParallaxLayer>
			</Parallax>
		</div>
	);
}

export default App;
